import { Formik, Form } from 'formik'

import { useUpdateLanguage } from 'src/hooks'
import { ILanguageBaseWithId, ILanguageForm } from 'src/types'
import { LanguageForm } from '../language-form'

import { languageSchema } from 'src/common/validations'

interface IProps {
  initialValues: ILanguageBaseWithId
  handleClose: () => void
}

const UpdateLanguageForm = ({ initialValues, handleClose }: IProps) => {
  const { mutateAsync: updateLanguage } = useUpdateLanguage()
  const handleSubmit = async (values: ILanguageForm) => {
    const resp = await updateLanguage({ ...values, languageId: initialValues.id })
    if (!resp) return

    handleClose()
  }

  return (
    <>
      <Formik
        initialValues={{
          name: initialValues.name,
          code: initialValues.code,
          enabled: initialValues.enabled,
        }}
        validationSchema={languageSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <LanguageForm isEditing />
        </Form>
      </Formik>
    </>
  )
}

export { UpdateLanguageForm }
